/* eslint-disable no-param-reassign */

/**
 * Convert to lower case, remove accents, remove non-word chars and
 * replace spaces with the specified delimeter.
 * Does not split camelCase text.
 */
import replaceAccents from './replaceAccents';
import removeNonWord from './removeNonWord';
import trim from './trim';

var slugify = function slugify(str) {
  var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  str = replaceAccents(str);
  str = removeNonWord(str);
  str = trim(str) // should come after removeNonWord
  .replace(/ +/g, delimeter) // replace spaces with delimeter
  .toLowerCase();
  return str;
};

export default slugify;